/** Shared author pill colors for Tagger feed and Tags explore rail (WhatsApp-style name column). */

import * as d3 from 'd3';

export type TaggerAuthorPillStyle = { background: string; borderColor: string };

/** Matches categorical coloring elsewhere (Tab10 / d3.schemeCategory10). */
export const TAGGER_AUTHOR_COLOR_COUNT = 10;

function category10PillFromHex(hex: string): TaggerAuthorPillStyle {
  const parsed = d3.rgb(hex);
  if (Number.isNaN(parsed.r)) {
    return {
      background: 'rgba(45, 51, 59, 0.92)',
      borderColor: 'rgba(139, 148, 158, 0.52)',
    };
  }
  const bg = parsed.darker(0.85);
  bg.opacity = 0.88;
  const bd = d3.rgb(hex).brighter(0.12).darker(0.4);
  bd.opacity = 0.52;
  return {
    background: bg.formatRgb(),
    borderColor: bd.formatRgb(),
  };
}

/** One entry per schemeCategory10 color, dark-UI pill fills (light text from CSS). */
const TAGGER_AUTHOR_PILL_BY_CATEGORY_INDEX: ReadonlyArray<TaggerAuthorPillStyle> =
  d3.schemeCategory10.map(category10PillFromHex);

/** Normalize display label for map keys (case-insensitive, stable). */
export function taggerAuthorNormalizedKey(label: string): string {
  return label.trim().toLowerCase() || 'unknown';
}

/**
 * Sorted unique authors → 0..n-1. Caller maps ordinals to pill colors with `% TAGGER_AUTHOR_COLOR_COUNT`.
 */
export function buildTaggerAuthorOrdinalMap(displayLabels: Iterable<string>): ReadonlyMap<string, number> {
  const set = new Set<string>();
  for (const raw of displayLabels) {
    set.add(taggerAuthorNormalizedKey(raw));
  }
  const sorted = [...set].sort((a, b) => a.localeCompare(b));
  const map = new Map<string, number>();
  sorted.forEach((k, i) => map.set(k, i));
  return map;
}

export function taggerAuthorPillStylesByOrdinal(ordinal: number): TaggerAuthorPillStyle {
  const n = TAGGER_AUTHOR_COLOR_COUNT;
  const i = ((ordinal % n) + n) % n;
  return TAGGER_AUTHOR_PILL_BY_CATEGORY_INDEX[i]!;
}
